
import { useState } from 'react';

const ContactJoinSection = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyWechat = () => {
    navigator.clipboard.writeText('shunnian2025').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-3 sm:mb-6">联系我们</h2>
          <p className="text-sm sm:text-xl text-gray-700 max-w-3xl mx-auto">
            期待与您携手共创美好未来，欢迎随时联系我们了解更多合作详情
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
            {/* 联系方式 */}
            <div className="flex flex-col justify-center">
              <div className="max-w-2xl mx-auto w-full">
                <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
                  {/* 电话 */}
                  <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-4 sm:p-6 text-center shadow-lg">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                      <i className="ri-phone-line text-white text-lg sm:text-xl"></i>
                    </div>
                    <h3 className="font-bold text-[#663333] mb-1 sm:mb-2 text-xs sm:text-sm">咨询热线</h3>
                    <p className="text-[#663333] font-medium text-xs sm:text-sm">400-8888-666</p>
                  </div>

                  {/* 微信 */}
                  <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-4 sm:p-6 text-center shadow-lg">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                      <i className="ri-wechat-line text-white text-lg sm:text-xl"></i>
                    </div>
                    <h3 className="font-bold text-[#663333] mb-1 sm:mb-2 text-xs sm:text-sm">微信号</h3>
                    <div className="flex items-center justify-center space-x-2">
                      <p className="text-[#663333] font-medium text-xs sm:text-sm">shunnian2025</p>
                      <button
                        onClick={handleCopyWechat}
                        className="w-4 h-4 sm:w-5 sm:h-5 bg-[#cc9966] rounded flex items-center justify-center hover:bg-[#bb8855] transition-colors cursor-pointer"
                        title="复制微信号"
                      >
                        <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} text-white text-xs`}></i>
                      </button>
                    </div>
                    {copied && (
                      <p className="text-green-600 text-xs mt-1">已复制</p>
                    )}
                  </div>

                  {/* 地址 */}
                  <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-4 sm:p-6 text-center shadow-lg">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                      <i className="ri-map-pin-line text-white text-lg sm:text-xl"></i>
                    </div>
                    <h3 className="font-bold text-[#663333] mb-1 sm:mb-2 text-xs sm:text-sm">公司地址</h3>
                    <p className="text-[#663333] font-medium text-xs sm:text-sm">云南省昆明市官渡区茶马花街88号</p>
                  </div>

                  {/* 工作时间 */}
                  <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-4 sm:p-6 text-center shadow-lg">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                      <i className="ri-time-line text-white text-lg sm:text-xl"></i>
                    </div>
                    <h3 className="font-bold text-[#663333] mb-1 sm:mb-2 text-xs sm:text-sm">工作时间</h3>
                    <p className="text-[#663333] font-medium text-xs sm:text-sm">周一至周五 9:00-18:00</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 合作承诺 */}
            <div className="flex flex-col justify-center">
              <div className="max-w-2xl mx-auto w-full">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 sm:p-8 shadow-lg">
                  <h3 className="text-lg sm:text-2xl font-bold text-[#663333] mb-4 sm:mb-6 text-center">我们的承诺</h3>
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex items-start space-x-3">
                      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                      </div>
                      <p className="text-[#663333] text-xs sm:text-sm">
                        <span className="font-semibold">专业支持：</span>提供全方位的产品培训和销售指导
                      </p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                      </div>
                      <p className="text-[#663333] text-xs sm:text-sm">
                        <span className="font-semibold">品质保证：</span>严格的品质控制，让您放心经营
                      </p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                      </div>
                      <p className="text-[#663333] text-xs sm:text-sm">
                        <span className="font-semibold">营销支持：</span>提供品牌推广和营销活动支持
                      </p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                      </div>
                      <p className="text-[#663333] text-xs sm:text-sm">
                        <span className="font-semibold">长期合作：</span>建立长期稳定的合作关系，共同发展
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactJoinSection;
